import React from 'react'

const SearchIcon = () => {
    return (
        <svg width="30" height="30" cursor="pointer" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.4999 17.4999L13.1691 13.1691M13.1691 13.1691C14.3412 11.9969 14.9997 10.4072 14.9997 8.7495C14.9997 7.09184 14.3412 5.50207 13.1691 4.32992C11.9969 3.15777 10.4072 2.49927 8.7495 2.49927C7.09184 2.49927 5.50207 3.15777 4.32992 4.32992C3.15777 5.50207 2.49927 7.09184 2.49927 8.7495C2.49927 10.4072 3.15777 11.9969 4.32992 13.1691C5.50207 14.3412 7.09184 14.9997 8.7495 14.9997C10.4072 14.9997 11.9969 14.3412 13.1691 13.1691Z" stroke="#2158D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default SearchIcon